import Customers from './Customers';

export default Customers;


// WEBPACK FOOTER //
// ./src/containers/Customers/index.js